import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	delete: {
		id: 'issue-attachments-table.delete-button.delete',
		defaultMessage: 'Delete attachment',
		description: 'Label for the delete single attachment button',
	},
});
